import { useMyCourseInstructor } from "../hooks/useMyCourseInstructor";
import { MyCourseBasicInfo } from "./MyCourseBasicInfo/MyCourseBasicInfo";
import { MyCourseClasses } from "./MyCourseClasses/MyCourseClasses";
import { MyCourseLogistics } from "./MyCourseLogistics/MyCourseLogistics";
import { MyCoursePublishing } from "./MyCoursePublishing/MyCoursePublishing";
import { MyCourseRemove } from "./MyCourseRemove/MyCourseRemove";
import { MyCourseStudents } from "./MyCourseStudents/MyCourseStudents";

export function RightContent() {
	const { course } = useMyCourseInstructor();

	if (!course) {
		return null;
	}

	const path = location.pathname.split("/").reverse()[0];

	if (path === "description") {
		return <MyCourseBasicInfo />;
	}

	if (path === "classes") {
		return <MyCourseClasses />;
	}

	if (path === "logistics") {
		return <MyCourseLogistics />;
	}

	if (path === "publishing") {
		return <MyCoursePublishing />;
	}

	if (path === "remove") {
		return <MyCourseRemove />;
	}

	if (path === "students") {
		return <MyCourseStudents />;
	}

	return null;
}
